<div class="hub-wrapper">
  <div class="hub-header">
    <h1 class="hub-title">ADMINISTRATION HUB</h1>
  </div>
  <div class="hub-body">
    <nav class="hub-sidebar">
      <a routerLink="mips-submission" routerLinkActive="active-link" class="hub-nav-item">
        <span>MIPS<br>SUBMISSION</span>
      </a>
      <a routerLink="mips-reviews" routerLinkActive="active-link" class="hub-nav-item">
        <span>MIPS<br>REVIEWS</span>
      </a>
    </nav>

    <div class="hub-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
